var elementsShipping = document.querySelectorAll(
  ".deliver-to-country-line, .selected-coutry,#box-shipping,.disclosure__toggle--country"
);
elementsShipping.forEach(function (element) {
  element.addEventListener("click", function () {
    var popupShippingCountryElement = document.querySelector(
      ".popup-shipping-country"
    ),
      currency = getCookieByProduct("currency") || "USD",
      selectCurrency = document.querySelector(
        "#currencies-country .currencies-country"
      );
    selectCurrency && (selectCurrency.value = currency);
    var bgCountryElement = document.querySelector(".bg-country");
    popupShippingCountryElement.classList.toggle("hidden"),
      bgCountryElement.classList.toggle("hidden");
  });
});
var closedShipping = document.querySelectorAll(
  ".bg-country,.img-closed-popup-shipping"
);
closedShipping.forEach(function (element) {
  element.addEventListener("click", function () {
    var popupShippingCountryElement = document.querySelector(
      ".popup-shipping-country"
    ),
      bgCountryElement = document.querySelector(".bg-country");
    popupShippingCountryElement.classList.toggle("hidden"),
      bgCountryElement.classList.toggle("hidden");
  });
}),
  $(document).ready(function () {
    var currency = $(".currencies").val();
    currency === "USD"
      ? ($("#pp-pay-later-message-desktop").show(),
        $("#pp-pay-later-message").show())
      : ($("#pp-pay-later-message-desktop").hide(),
        $("#pp-pay-later-message").hide());
  }),
  $("body").on("change", ".currencies", function (e) {
    var currency = $(this).val();
    currency === "USD"
      ? ($("#pp-pay-later-message-desktop").show(),
        $("#pp-pay-later-message").show())
      : ($("#pp-pay-later-message-desktop").hide(),
        $("#pp-pay-later-message").hide());
  });
function getCookieByProduct(key) {
  var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
  return keyValue ? keyValue[2] : null;
}
function init () {
  const deliver = document.querySelector(".deliver-to-country-line");
  const shipping = document.querySelector(".new-shipping");
  const modalShipping = document.querySelector('.modal-shipping[data-index="1"]');
  if(modalShipping){
    document.addEventListener("click", (event) => {
      // Check if the clicked target is INSIDE the specific element
      if (!document.querySelector('.new-shipping').contains(event.target)) {
          modalShipping.classList.remove('show')
      }else{
        modalShipping.classList.add('show')
      }
  });
    document.querySelector('.icon-closed-fulfillment').addEventListener('click',() => {
      modalShipping.classList.remove('show')
    })
  }
  const insertAfterElement = document.querySelector(
    ".tee-block.tee-product-price"
  ) || document.querySelector('[id*="price-template--"]')
  
  if (shipping && insertAfterElement) {
    insertAfterElement.after(shipping);
  }
  if (shipping && modalShipping) {
  shipping.after(modalShipping);
}
  if (deliver && insertAfterElement) {
    insertAfterElement.after(deliver);
  }
  if(document.querySelector('shopify-payment-terms') != null && deliver){
    deliver.before(document.querySelector('shopify-payment-terms'))
  }
  if (insertAfterElement) {
    const spanElement = document.createElement("span");
    spanElement.className = "badge price__badge-sale color-scheme-4";
    spanElement.textContent = "Sale";
    if(document.querySelector(".money.theme-money.price.tee-price--compare") != null){
      insertAfterElement.appendChild(spanElement);
    }
  }
}
document.addEventListener("teeinblue-event-component-injected", init)